import Scribe from "./scribe";
export * from './qr-code-scribe';

export default Scribe;
